/* eslint-disable semi */
import * as utils from './utils';

const debug = process.env.NODE_ENV === 'development';

/**
 * 非同期バリデーションの検証用バリデータ
 * @param {*} rule
 * @param {*} value
 * @param {*} callback
 * @param {*} source
 * @param {*} options
 */
export function devAsync (rule, value, callback, source, options) {
  var errors = [];
  if (debug) {
    errors.push(utils.getMessageTemplate(rule, options));
    setTimeout(() => {
      callback(errors);
    }, 2000);
  } else {
    callback(errors);
  }
}



// WEBPACK FOOTER //
// ./src/core/rules/dev-async.js